<template>
  <v-autocomplete test-tag="tag-1511"
    @input="onInput"
    :multiple="multiSelect"
    :value="value"
    :items="dealers"
    :item-text="item => item.name"
    item-value="id"
    :rules="[]"
    hide-details
  >
    <template v-slot:prepend-item v-if="multiSelect">
      <v-btn @click="onAddAll" icon test-tag="tag-547"><v-icon>mdi-playlist-plus</v-icon></v-btn>
      <v-btn @click="onRemoveAll" icon test-tag="tag-548"><v-icon>mdi-playlist-minus</v-icon></v-btn>
    </template>

    <template v-slot:append-item v-if="multiSelect">
      <v-btn @click="onAddAll" icon test-tag="tag-549"><v-icon>mdi-playlist-plus</v-icon></v-btn>
      <v-btn @click="onRemoveAll" icon test-tag="tag-550"><v-icon>mdi-playlist-minus</v-icon></v-btn>
    </template>

    <template v-slot:selection="{ item, index }">
      <div v-if="multiSelect">
        <div v-if="value.length === dealers.length && index === 0">
          <span>
            Выбраны все дилеры ({{value.length}})
          </span>
        </div>
        <div v-else-if="value.length !== dealers.length">
          <v-chip small v-if="index < maxItemsInField">
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === maxItemsInField" class="text-grey text-caption align-self-center">
            ещё {{ value.length - maxItemsInField }}
          </span>
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>

export default {
  name: 'dealers-selector',

  props: {
    value: { type: Array, default: () => [] },
    hideDetails: { type: Boolean, default: false },
    notEmpty: { type: Boolean, default: true },
    label: { type: String, default: "Дилеры" },
    multiSelect: { type: Boolean, default: false },
    enableNoDealers: { type: Boolean, default: false },
    showingDeleted: { type: Boolean, default: false }
  },

  data: () => ({
    maxItemsInField: 7,
  }),

  mounted () {
    this.onAddAll();
    if (this.multiSelect) {
      this.onAddAll();
    }
    else {
      this.onInput(this.value);
    }
  },

  watch: {
    dealers: {
      handler (newDealers) {
        const onlyNoDealersSelected = this.value.length === 1 && this.value[0] === 'NO_DEALERS';
        const moreDealersAvailable = newDealers.length > this.value.length;

        if (this.multiSelect && (this.value.length === 0 || (onlyNoDealersSelected && moreDealersAvailable))) {
          this.onAddAll();
        }
        else {
          this.onInput(this.value);
        }
      },
      immediate: false
    }
  },

  computed: {
    dealers: function () {
      let dealerList = this.$store.getters.dealers.filter(
        (dealer) => this.showingDeleted ? true : !dealer.isDeleted
      ).map((v) => {
        return {
            name: `${v.name} (${v.id})`,
            id: v.id,
        }
      })
      dealerList.sort((a, b) => {
        return a.id > b.id
      })
      return dealerList
    },
  },

  methods: {
    onInput (value) {
      this.$emit('input', value);
    },

    onAddAll () {
      const allIds = this.dealers.filter(t => t.id !== null).map(t => t.id);
      this.onInput(allIds);
    },

    onRemoveAll () {
      this.onInput([]);
    }
  }
};
</script>
